import { Routes } from '@angular/router';
import { ErrorComponent } from './+shared/components/error.component/error.component';
import { ContactSupportComponent } from './components/contact-support.component/contact-support/contact-support.component';
import { NetsPaymentReturnNetaxeptComponent } from './components/nets-payment-return-netaxept.component/nets-payment-return-netaxept.component';
import { ReceiptComponent } from './components/receipt.component/receipt.component';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./+login/login.module').then((m) => m.LoginModule),
    data: { preload: true },
  },
  {
    path: 'aktuelle-konkurrencer',
    loadChildren: () =>
      import('./+competitions/competitions.module').then((m) => m.CompetitionsModule),
  },
  {
    path: 'lykkenummer',
    loadChildren: () =>
      import('./+lucky-number/lucky-number.module').then((m) => m.LuckyNumberModule),
  },
  {
    path: 'lodder-til-salg',
    loadChildren: () =>
      import('./+shop-purchase/shop-purchase.module').then((m) => m.ShopPurchaseModule),
    data: { preload: true },
  },
  {
    path: 'betaling',
    loadChildren: () =>
      import('./+checkout-purchase/checkout-purchase.module').then((m) => m.CheckoutPurchaseModule),
    data: { preload: true },
  },
  {
    path: 'min-side/saadan-aendrer-du-dine-oplysninger',
    loadChildren: () =>
      import('./+how-to-change-info/how-to-change-info.module').then(
        (m) => m.HowToChangeInfoModule
      ),
  },
  {
    path: 'har-jeg-vundet',
    loadChildren: () =>
      import('./+ticket-win-history/ticket-win-history.module').then(
        (m) => m.TicketWinHistoryModule
      ),
  },
  {
    path: 'afmeld',
    loadChildren: () =>
      import('./+unsubscribe/unsubscribe.module').then((m) => m.UnsubscribeModule),
  },
  {
    path: 'spilmed',
    loadChildren: () => import('./+bs-signup/bs-signup.module').then((m) => m.BsSignupModule),
  },
  {
    path: 'glade-vindere',
    loadChildren: () =>
      import('./+happy-winners/happy-winners.module').then((m) => m.HappyWinnersModule),
  },
  {
    path: 'om-klasselotteriet',
    loadChildren: () => import('./+about/about.module').then((m) => m.AboutModule),
  },
  { path: 'fejl', component: ErrorComponent },
  { path: 'nets-payment-return-netaxept', component: NetsPaymentReturnNetaxeptComponent },
  { path: 'kvittering/:orderid', component: ReceiptComponent },
  { path: 'kvittering', component: ReceiptComponent },
  {
    path: 'navigate-web-root',
    loadChildren: () =>
      import('./components/navigate-web-root.component/navigate-web-root.module')
        .then(m => m.NavigateWebRootModule),
  },
  {
    path: 'retningslinjer',
    loadChildren: () =>
      import('./components/guidelines.component/guidelines.module')
        .then(m => m.GuidelinesModule),
  },
  { path: 'kontakt-os', component: ContactSupportComponent },
  {
    path: '15',
    loadChildren: () =>
      import('./+shared/components/info-pricing-update-landingpage.component/info-pricing-update-landingpage.module')
        .then(m => m.InfoPricingUpdateLandingpageModule),
  },
  { path: 'aktive-lodder', redirectTo: 'min-side', pathMatch: 'full' },

  // Wildcard route MUST be last
  { path: '**', component: ErrorComponent }
];
